/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_Request_ExamplesInputs */

const en_directory_agent_readiness_check_request_examples = /** @type {(inputs: Directory_Agent_Readiness_Check_Request_ExamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request examples`)
};

const zh_directory_agent_readiness_check_request_examples = /** @type {(inputs: Directory_Agent_Readiness_Check_Request_ExamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请求示例`)
};

/**
* | output |
* | --- |
* | "Request examples" |
*
* @param {Directory_Agent_Readiness_Check_Request_ExamplesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_request_examples = /** @type {((inputs?: Directory_Agent_Readiness_Check_Request_ExamplesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_Request_ExamplesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_request_examples(inputs)
	return zh_directory_agent_readiness_check_request_examples(inputs)
});
export { directory_agent_readiness_check_request_examples as "directory.agent_readiness.check.request_examples" }